import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from "@angular/router";
import { RouterStateSerializer } from "@ngxs/router-plugin";

export interface RouterStateParams {
  url: string;
  params: Params;
  root: ActivatedRouteSnapshot;
  data: any;
}

export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateParams> {
  serialize(routerState: RouterStateSnapshot): RouterStateParams {
    const {
      url,
      root
    } = routerState;
    let { root: route } = routerState;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const { params, data } = route;
    return { url, params, root, data };
  }
}
